import { Navigate } from 'react-router';
import { useProductStore } from '@/stores/product';
import { usePermissions } from '@/hooks/usePermissions';

const PRIORITY_ROUTES = [
  { featureKey: 'get_started.setup_guide', path: '/setup' },
  { featureKey: 'analytics.dashboards', path: '/bi' },
  { featureKey: 'ingestion.data_sources', path: '/data-sources' },
  { featureKey: 'ingestion.pipelines', path: '/pipelines' },
  { featureKey: 'data_lake.catalog', path: '/catalog' },
  { featureKey: 'data_lake.explorer', path: '/queries' },
  { featureKey: 'scout.scout', path: '/ai' },
] as const;

export function DefaultRedirect() {
  const { branding } = useProductStore();
  const { can } = usePermissions();

  // Product mode: go to dashboards if accessible, otherwise fall through to priority list
  if (branding && can('analytics.dashboards')) {
    return <Navigate to="/bi" replace />;
  }

  const first = PRIORITY_ROUTES.find(({ featureKey }) => can(featureKey));
  return <Navigate to={first?.path ?? '/setup'} replace />;
}
